import React from 'react'
import { FMCSA, IFMCSA } from '../Fmcsa'
import { FSMA, IFSMA } from '../Fsma'
import { W9Form, IW9Form } from '../W9Form'

interface IReviewedDocumentProps {
  type: string
  checklists: {
    w9FormReviewedBy: IW9Form
    fmcsaInfoVerifiedBy: IFMCSA
    fsmaInfoReviewedBy: IFSMA
  }
}

export const ReviewedDocument: React.FunctionComponent<IReviewedDocumentProps> = React.memo(
  ({ checklists, type }) => {
    if (type === 'w9FormReviewedById') return <W9Form w9Form={checklists.w9FormReviewedBy} />
    if (type === 'fmcsaInfoVerifiedById') return <FMCSA fmcsa={checklists.fmcsaInfoVerifiedBy} />
    if (type === 'fsmaInfoReviewedById') return <FSMA fsma={checklists.fsmaInfoReviewedBy} />
    return <></>
  }
)
